import { Injectable } from '@angular/core';
import { LoadingController, AlertController } from 'ionic-angular';
import { ResidentialService } from '../services/residential.service';
import { ResidentialModel } from '../models/residential.model';
import { ImagesService } from '../services/images.service';
import { ImageModel } from '../models/image.model';

@Injectable()
export class ResidentialStore {

    private loader: any = null;

    public data: ResidentialModel;
    public images: Array<ImageModel>;    
    public showLoader: boolean = true;

    constructor(
        private service: ResidentialService,
        private imgService: ImagesService,
        private loadingCtrl: LoadingController,
        private alertCtrl: AlertController) { }

    load(id: string) {

        this.startLoad();

        this.images = null;        

        let observable = this.service.property(id);

        observable.subscribe(
            data => {
                this.data = data;

                this.endLoad();
            },
            error => {

                // console.log('[ResidentialStore] load | error: ');
                // console.log(error);

                this.endLoad();
                this.presentAlert('Errore', 'Impossibile recuperare dal server la risorsa richiesta.');
            });

        return observable.toPromise();
    }

    loadImages() {

        if (this.data && this.data.Id_Pratica) {

            this.startLoad();

            let observable = this.imgService.images(this.data.Id_Pratica);

            observable.subscribe(
                data => {                   

                    this.images = new Array<ImageModel>();

                    for (let i = 0; i < data.length; i++)
                    {                        
                        let img = new ImageModel(data[i]);

                        this.images.push(img);
                    }

                    // Si assicura che l'array sia ordinato per "Numero"
                    this.images.sort((a: ImageModel, b: ImageModel) => {

                        return (a.Numero - b.Numero);
                    });

                    this.endLoad();
                },
                error => {

                    // console.log('[ResidentialStore] loadImages | error: ');
                    // console.log(error);

                    this.endLoad();

                    // ToDo: verificare se è necessario presentare un avviso all'utente se nessuna foto è stata trovata
                    // this.presentAlert('Attenzione', 'Nessuna immagine trovata.');  
                }
            )

        }

        return null; // ToDo: restituire comunque una promise?
    }

    private startLoad() {
        if (this.showLoader)
            this.presentLoading();
    }

    private endLoad() {
        if (this.loader)
            this.loader.dismiss();
    }

    private presentLoading() {

        this.loader = this.loadingCtrl.create({
            content: "Caricamento..."
        });
        this.loader.present();
    }

    private presentAlert(title: string, message: string) {

        let alert = this.alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: ['OK']
        });
        alert.present();
    }
}


// WEBPACK FOOTER //
// ./src/stores/residential.store.ts